import { render, staticRenderFns } from "./ReportSections.vue?vue&type=template&id=2ab068b0&"
import script from "./ReportSections.vue?vue&type=script&lang=js&"
export * from "./ReportSections.vue?vue&type=script&lang=js&"
import style0 from "./ReportSections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports